<template>
  <div class="container">
    <announcement/>
    <div class="Clerk" v-if="hasRole('clerk')">
      <div class="header">
        <img :src="clerk.avatarUrl" class="avatarUrl"/>
        <div class="right">
          <div class="line">
            <div class="name">{{clerk.name}}</div>
            <div @click="$router.push( '/clerk/info')" class="toInfo" v-if="$ClerkAccess.includes('info')">
              个人资料
              <img src="/static/images/1508/arrow2.png" class="arrow"/>
            </div>
          </div>
          <div class="grade">
            {{clerk.grade}}
          </div>
        </div>
      </div>

      <div class="module1">
        <div class="title">功能开关</div>
        <div class="switch">
          <div class="switchItem" v-if="$hasFeature('auto_online')">
            <van-switch v-model="clerkIsAutoOnline" active-color="var(--primary-color)"
                        style="margin-left: 17px; margin-right: 5px"
                        inactive-color="#E6E6E6"
                        size="19" @input="(input)=>updateClerkIsAutoOnline(input)"/>
            <span v-if="clerkIsAutoOnline" style="color:var(--primary-color);">自动在线</span>
            <span v-else-if="!clerkIsAutoOnline" class="text-gray">手动在线</span>
          </div>
          <div class="switchItem">
            <van-switch :active-value="1" :inactive-value="2" :loading="updateClerkStatusLoading"
                        :value="clerk.status"
                        active-color="var(--primary-color)" style="margin-left: 17px; margin-right: 5px"
                        inactive-color="#E6E6E6"
                        size="19"
                        @input="(input)=>updateStatus(input,'clerk')"/>
            <span v-if="clerk.status == 1" style="color:var(--primary-color);">我可以秒接单</span>
            <span v-else-if="clerk.status == 2" class="text-gray">离线</span>
          </div>
          <div class="switchItem" v-if="$ClerkPermission.modifiableClerkAttr.includes('randomOrderSwitch')">
            <van-switch :value="clerk && clerk.randomOrderSwitch" active-color="var(--primary-color)"
                        style="margin-left: 17px; margin-right: 5px" inactive-color="#E6E6E6"
                        size="19" @input="(input)=>updateRandomOrderSwitch(input)"/>
            <span :style="{color: clerk && clerk.randomOrderSwitch?'var(--primary-color)':'gray'}"
                  class="flex align-center">
              随机单<question-mark style="margin-left: 3px" msg="在线且随机单开启时，才会接收到随机单通知"/>
            </span>
          </div>
          <div class="switchItem" v-if="$hasFeature('clerk_recommend_on')">
            <van-switch :active-value="true" :inactive-value="false" :loading="updateClerkRecommendOnLoading"
                        :value="clerk.isRecommendOn"
                        active-color="var(--primary-color)" style="margin-left: 17px; margin-right: 5px"
                        inactive-color="#E6E6E6"
                        size="19"
                        @input="(input)=>updateRecommendOn(input)"/>
            <span :style="{color: clerk && clerk.isRecommendOn?'var(--primary-color)':'gray'}">
              我要上推荐<question-mark style="margin-left: 3px" msg="在线状态才可开启，离线会自动关闭，开启满5个小时会自动关闭，开启期间有超时单或投诉单会被隐藏并关闭上推荐状态"/>
            </span>
          </div>
        </div>
        <div class="skillSwitch" @click="$router.push('/skillSwitch?switch=fixedList')">
          个人主页服务技能开关
          <img src="/static/images/1508/arrow2.png" class="arrow"/>
        </div>
        <div class="skillSwitch" @click="$router.push('/skillSwitch?switch=randomList')">
          接收呼叫店员技能开关
          <img src="/static/images/1508/arrow2.png" class="arrow"/>
        </div>
      </div>

      <div class="module2">
        <div class="title">常用工具</div>
        <div class="rowBox">
          <router-link class="Item" to="balance">
            <img src="/static/images/1508/icon1.png" class="icon"/>
            我的钱包
          </router-link>
          <router-link class="Item" to="/clerk/order/list" v-if="$ClerkAccess.includes('order')">
            <img src="/static/images/1508/icon2.png" class="icon"/>
            我的订单
          </router-link>
          <router-link class="Item" to="/clerk/random" v-if="$ClerkAccess.includes('random')">
            <img src="/static/images/1508/icon3.png" class="icon"/>
            抢单大厅
          </router-link>
          <router-link class="Item" to="/clerk/gift" v-if="$hasFeature('gift_wall') && $ClerkAccess.includes('gift')">
            <img src="/static/images/1508/icon4.png" class="icon"/>
            我的礼物
          </router-link>
          <router-link class="Item" to="/clerk/grade" v-if="$ClerkAccess.includes('grade')">
            <img src="/static/images/1508/icon5.png" class="icon"/>
            我的等级
          </router-link>
          <router-link class="Item" to="/clerk/ranking-list" v-if="($hasFeature('clerk_ranking') || $store.state.shop.version === 'combination') && $ClerkAccess.includes('ranking-list')">
            <img src="/static/images/1508/icon6.png" class="icon"/>
            我的排名
          </router-link>
          <router-link class="Item" to="/clerk/post/list" v-if="$hasFeature('post_list') && $ClerkAccess.includes('post-list')">
            <img src="/static/images/1508/icon7.png" class="icon"/>
            发布动态
          </router-link>
          <router-link class="Item" to="/clerk/reward-log" v-if="$ClerkAccess.includes('reward-log')">
            <img src="/static/images/1508/icon8.png" class="icon"/>
            打赏动态
          </router-link>
          <router-link class="Item" to="/clerk/item-price" v-if="$hasFeature('clerk_item_price') && $ClerkAccess.includes('item-price')">
            <img src="/static/images/1508/icon9.png" class="icon"/>
            服务价格
          </router-link>
          <router-link class="Item" to="/clerk/clerk-category-apply-list" v-if="$hasFeature('clerk_category_apply') && $ClerkAccess.includes('clerk_category_apply') && clerkJoinCategoryApply">
            <img src="/static/images/1508/icon10.png" class="icon"/>
            技能申请
          </router-link>
          <router-link class="Item" to="/clerk/sign-in" v-if="$hasFeature('clerk_point')">
            <img src="/static/images/1508/icon11.png" class="icon"/>
            签到
          </router-link>
          <router-link class="Item" to="/article/list?type=2" v-if="$ClerkAccess.includes('manual')">
            <img src="/static/images/1508/icon12.png" class="icon"/>
            店员手册
          </router-link>
          <router-link class="Item" to="/clerk/honor" v-if="$hasFeature('gift_book')">
            <img src="/static/images/1508/icon13.png" class="icon"/>
            礼物成就
          </router-link>
        </div>
      </div>
    </div>

    <van-cell-group v-if="hasRole('kf')" title="客服">
      <div slot="title" style="position: relative;">客服
        <div v-if="kf != null" class="clerk-status">
          <span v-if="kf.status == 1" style="color: var(--primary-color)">在线</span>
          <span v-else-if="kf.status == 2" class="text-gray">离线</span>
          <van-switch :active-value="1" :inactive-value="2" :loading="updateKfStatusLoading"
                      :value="kf.status"
                      active-color="var(--primary-color)" class="margin-left-sm" inactive-color="var(--grey)"
                      size="24"
                      @input="(input)=>{updateStatus(input,'kf')}"/>
        </div>
      </div>
      <van-row class="grid">
        <van-col v-if="$KfAccess.includes('manual')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/article/list?type=3">
            <van-icon color="var(--primary-color)" name="description" size="30px"/>
            <div class="text">客服手册</div>
          </router-link>
        </van-col>
        <van-col v-if="$KfAccess.includes('order')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/order/list">
            <van-icon color="var(--primary-color)" name="orders-o" size="30px"/>
            <div class="text">订单</div>
          </router-link>
        </van-col>
        <van-col v-if="$KfAccess.includes('order-rate')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/order/rate-list">
            <van-icon color="var(--primary-color)" name="completed" size="30px"/>
            <div class="text">订单评价</div>
          </router-link>
        </van-col>
        <van-col v-if="$KfAccess.includes('order-complain')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/order/complain-list">
            <van-icon color="var(--primary-color)" name="failure" size="30px"/>
            <div class="text">订单投诉</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('kf_wage_statistics') && $KfAccess.includes('wages')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/wages">
            <van-icon color="var(--primary-color)" name="balance-o" size="30px"/>
            <div class="text">工资</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('order_entry_list') && $KfAccess.includes('order-entry')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/order-entry">
            <van-icon color="var(--primary-color)" name="records" size="30px"/>
            <div class="text">订单录入</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('first_order') && $KfAccess.includes('first-order')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/first-order">
            <van-icon color="var(--primary-color)" name="records" size="30px"/>
            <div class="text">首单体验</div>
          </router-link>
        </van-col>
        <van-col v-if="$KfAccess.includes('continued-apply') && $hasFeature('order_continued_apply')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/order/continued-apply">
            <van-icon color="var(--primary-color)" name="completed" size="30px"/>
            <div class="text">续单审核</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('out_order') && $KfAccess.includes('out-order')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/order/out-order-list">
            <van-icon color="var(--primary-color)" name="orders-o" size="30px"/>
            <div class="text">外部订单</div>
          </router-link>
        </van-col>
        <van-col v-if="$KfAccess.includes('user-manage')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/kf/user/user-list">
            <van-icon color="var(--primary-color)" name="manager-o" size="30px"/>
            <div class="text">用户管理</div>
          </router-link>
        </van-col>
      </van-row>
    </van-cell-group>

    <van-cell-group v-if="$hasFeature('guild') && hasRole('guilder')" title="会长">
      <div slot="title" style="position: relative;">会长
      </div>
      <van-row class="grid">
        <van-col v-if="$GuilderAccess.includes('clerk-check-list')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right"
                       to="/guilder/clerk-check/clerk-check-list">
            <van-icon color="var(--primary-color)" name="friends-o" size="30px"/>
            <div class="text">店员资料审核</div>
          </router-link>
        </van-col>
        <van-col
            v-if="$hasFeature('post_list') && ( $hasRole('super_admin') || $GuilderAccess.includes('post-list'))"
            span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/guilder/post-list">
            <van-icon color="var(--primary-color)" name="chat-o" size="30px"/>
            <div class="text">动态管理</div>
          </router-link>
        </van-col>
        <van-col v-if="$GuilderAccess.includes('clerk-apply')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/guilder/clerk-apply-list">
            <van-icon color="var(--primary-color)" name="friends-o" size="30px"/>
            <div class="text">新店员申请</div>
          </router-link>
        </van-col>
        <van-col v-if="$GuilderAccess.includes('clerk-performance')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/guilder/clerkPerformance">
            <van-icon color="var(--primary-color)" name="bar-chart-o" size="30px"/>
            <div class="text">店员业绩</div>
          </router-link>
        </van-col>
        <van-col v-if="$GuilderAccess.includes('leader-wages')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/guilder/leaderWages">
            <van-icon color="var(--primary-color)" name="balance-o" size="30px"/>
            <div class="text">组长工资</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('clerk_category_apply') && $GuilderAccess.includes('clerk_category_examine_check')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right"
                       to="/guilder/clerk-category-examine-check">
            <van-icon color="var(--primary-color)" name="friends-o" size="30px"/>
            <div class="text">店员技能审核</div>
          </router-link>
        </van-col>
      </van-row>
    </van-cell-group>

    <van-cell-group v-if="hasRole('leader')" title="组长">
      <div slot="title" style="position: relative;">组长
        <div v-if="leader != null" class="clerk-status">
          <span v-if="leader.status == 1" style="color: var(--primary-color)">在线</span>
          <span v-else-if="leader.status == 2" class="text-gray">离线</span>
          <van-switch :active-value="1" :inactive-value="2" :loading="updateLeaderStatusLoading"
                      :value="leader.status"
                      active-color="var(--primary-color)" class="margin-left-sm" inactive-color="var(--grey)"
                      size="24"
                      @input="(input)=>{updateStatus(input,'leader')}"/>
        </div>
      </div>
      <van-row class="grid">
        <van-col v-if="$LeaderAccess.includes('manual')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/article/list?type=4">
            <van-icon color="var(--primary-color)" name="description" size="30px"/>
            <div class="text">组长手册</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('order')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/order/list">
            <van-icon color="var(--primary-color)" name="orders-o" size="30px"/>
            <div class="text">订单</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('order-rate')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/order/rate-list">
            <van-icon color="var(--primary-color)" name="completed" size="30px"/>
            <div class="text">订单评价</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('order-complain')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/order/complain-list">
            <van-icon color="var(--primary-color)" name="failure" size="30px"/>
            <div class="text">订单投诉</div>
          </router-link>
        </van-col>
        <van-col v-if=" $hasFeature('leader_wage_statistics') && $LeaderAccess.includes('wages')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/wages">
            <van-icon color="var(--primary-color)" name="balance-o" size="30px"/>
            <div class="text">工资</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('clerk-apply-list')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/clerk-apply-list">
            <van-icon color="var(--primary-color)" name="friends-o" size="30px"/>
            <div class="text">新店员申请</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('clerk-check-list')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right"
                       to="/leader/clerk-check/clerk-check-list">
            <van-icon color="var(--primary-color)" name="friends-o" size="30px"/>
            <div class="text">店员资料审核</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('post_list') && $LeaderAccess.includes('clerk-post-check-list')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right"
                       to="/leader/clerk-post-check-list">
            <van-icon color="var(--primary-color)" name="chat-o" size="30px"/>
            <div class="text">动态审核</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('continued-apply') && $hasFeature('order_continued_apply')"
                 span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/continued-apply">
            <van-icon color="var(--primary-color)" name="completed" size="30px"/>
            <div class="text">续单审核</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('clerk-manage')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/clerk-manage">
            <van-icon color="var(--primary-color)" name="manager-o" size="30px"/>
            <div class="text">店员管理</div>
          </router-link>
        </van-col>
        <van-col v-if="$LeaderAccess.includes('clerk-performance')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/clerk-performance">
            <van-icon color="var(--primary-color)" name="bar-chart-o" size="30px"/>
            <div class="text">店员业绩</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('clerk_category_apply') && $LeaderAccess.includes('clerk_category_examine_check')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right"
                       to="/leader/clerk-category-examine-check">
            <van-icon color="var(--primary-color)" name="friends-o" size="30px"/>
            <div class="text">店员技能审核</div>
          </router-link>
        </van-col>
      </van-row>
    </van-cell-group>

    <van-cell-group v-if="hasRole('admin')" title="管理员">
      <van-row class="grid">
        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('order')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/order/list">
            <van-icon color="var(--primary-color)" name="orders-o" size="30px"/>
            <div class="text">订单</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('order-rate')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/order/rate-list">
            <van-icon color="var(--primary-color)" name="completed" size="30px"/>
            <div class="text">订单评价</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('order-complain')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/order/complain-list">
            <van-icon color="var(--primary-color)" name="failure" size="30px"/>
            <div class="text">订单投诉</div>
          </router-link>
        </van-col>
        <van-col
            v-if="$hasFeature(['clerk_group','leader_wage_statistics']) &&( $hasRole('super_admin') || $AdminAccess.includes('leader-wages'))"
            span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/leader-wages">
            <van-icon color="var(--primary-color)" name="balance-o" size="30px"/>
            <div class="text">组长工资</div>
          </router-link>
        </van-col>
        <van-col
            v-if="$hasFeature('kf_wage_statistics') && ($hasRole('super_admin') || $AdminAccess.includes('kf-wages'))"
            span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/kf-wages">
            <van-icon color="var(--primary-color)" name="balance-o" size="30px"/>
            <div class="text">客服工资</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('clerk-performance')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/clerk-performance">
            <van-icon color="var(--primary-color)" name="bar-chart-o" size="30px"/>
            <div class="text">店员业绩</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('clerk-manage')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/clerk-manage">
            <van-icon color="var(--primary-color)" name="manager-o" size="30px"/>
            <div class="text">店员管理</div>
          </router-link>
        </van-col>
        <van-col
            v-if="$hasFeature('post_list') && ( $hasRole('super_admin') || $AdminAccess.includes('post-list'))"
            span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/post-list">
            <van-icon color="var(--primary-color)" name="chat-o" size="30px"/>
            <div class="text">动态管理</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('check-list')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/check-list">
            <van-icon color="var(--primary-color)" name="friends-o" size="30px"/>
            <div class="text">店员资料审核</div>
          </router-link>
        </van-col>
        <van-col
            v-if=" ($hasRole('super_admin') || $AdminAccess.includes('continued-apply')) && $hasFeature('order_continued_apply')"
            span="8">
          <router-link class="item van-hairline--bottom van-hairline--right"
                       to="/admin/order/continued-apply">
            <van-icon color="var(--primary-color)" name="completed" size="30px"/>
            <div class="text">续单审核</div>
          </router-link>
        </van-col>

        <van-col v-if="$store.state.shop.platform == $store.state.ShopPlatformEnum.DINGTALK.value" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/leader/get_userid">
            <van-icon color="var(--primary-color)" name="more-o" size="30px"/>
            <div class="text">获取用户ID</div>
          </router-link>
        </van-col>
        <van-col v-if="$AdminAccess.includes('clerk-apply')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/clerk-apply-list">
            <van-icon color="var(--primary-color)" name="friends-o" size="30px"/>
            <div class="text">新店员申请</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('user-manage')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/user/user-list">
            <van-icon color="var(--primary-color)" name="manager-o" size="30px"/>
            <div class="text">用户管理</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('tech_support_visitor') && $hasRole('super_admin')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/tech-support-visitor-list">
            <van-icon color="var(--primary-color)" name="manager-o" size="30px"/>
            <div class="text">开店咨询</div>
          </router-link>
        </van-col>
        <van-col v-if="$hasFeature('clerk_category_apply') && $AdminAccess.includes('clerk_category_examine_check')" span="8">
          <router-link class="item van-hairline--bottom van-hairline--right" to="/admin/clerk-category-examine-check">
            <van-icon color="var(--primary-color)" name="friends-o" size="30px"/>
            <div class="text">店员技能审核</div>
          </router-link>
        </van-col>
      </van-row>
    </van-cell-group>

    <van-row v-if="clerkWarning" type="flex" justify="center" align="center" :style="'margin-top:10rem;'">
      <van-col span="8" :style="'text-align:center'">
        <van-icon name="warning" color="lightblue" size="8rem"/>
      </van-col>
      <van-col span="24" align="center" :style="'margin-top:10px;font-weight:bold;text-align:center'">
        <div>您已被下架，没有权限访问</div>
      </van-col>
    </van-row>

    <van-row v-if="isResigned" type="flex" justify="center" align="center" :style="'margin-top:10rem;'">
      <van-col span="8" :style="'text-align:center'">
        <van-icon name="warning" color="lightblue" size="8rem"/>
      </van-col>
      <van-col span="24" align="center" :style="'margin-top:10px;font-weight:bold;text-align:center'">
        <div>您已离职，需要复职请联系店铺管理员。</div>
      </van-col>
    </van-row>

    <div class="text-center padding-tb">
      <router-link to="/clear-storage">清理缓存</router-link>
    </div>

    <foot></foot>

  </div>
</template>

<script>
import Vue from 'vue';
import {Cell, CellGroup, Col, Dialog, Icon, Row, Switch, Toast} from 'vant';
import {
  getClerk,
  getItemSwitchList,
  updateClerkAutoOnlineStatus,
  updateClerkStatus,
  updateItemSwitch,
  updateRandomOrderSwitch,
  updateRecommendOn
} from '@/api/clerk/clerk'
import foot from '@/views/foot';
import {getKf, updateKfStatus} from "@/api/kf/kf";
import {getLeader, updateLeaderStatus} from "@/api/leader/leader";
import {getClerkSetting} from "@/api/shop";
import QuestionMark from "@/views/question-mark";
import announcement from "@/views/announcement";
import {getRegionTime, setRegionTime} from "../../libs/util";
import axios from 'axios'
import moment from "moment";
import areas from '_pub/static/areas'
import {updateRegion} from '@/api/clerk/clerk'

Vue.use(Row)
    .use(Col)
    .use(Icon)
    .use(CellGroup)
    .use(Cell)
    .use(Switch)
    .use(Dialog)
    .use(Toast)

export default {
  name: 'index',
  components: {
    announcement,
    QuestionMark,
    foot
  },
  data() {
    return {
      showOpenShop: false,
      roles: null,
      clerkIsAutoOnline: false,
      clerk: {},
      dispatchOrderPermission: [],
      kf: null,
      leader: null,
      updateClerkRecommendOnLoading: false,
      updateClerkStatusLoading: false,
      updateKfStatusLoading: false,
      updateLeaderStatusLoading: false,
      itemSwitchList: [],
      clerkItemSwitchIds: [],
      allowRandomOrderSwitch: null,
      clerkWarning: false,
      isResigned: false,
      removeClerkRole: null,
      specifySwitch: [],
      randomSwitch: [],
      specifyShow: true,
      randomShow: false,
      clerkJoinCategoryApply: false,
    }
  },
  methods: {
    hasRole(role) {
      if (this.roles == null) {
        return false;
      }
      return this.roles.indexOf(role) != -1;
    },
    verifyRole() {
      if (this.roles == null || this.roles.length == 0) {
        if (this.removeClerkRole) {
          this.clerkWarning = true
        } else {
          this.$router.replace('/noAccount')
        }
      } else if (this.roles.length == 1 && this.hasRole('user')) {
        // 这里是限制只是店员角色 但是已经离职了 就显示离职提示
        if (this.$store.state.isResigned) {
          this.isResigned = true
        } else if (this.removeClerkRole) {
          this.clerkWarning = true
        } else {
          this.$router.replace('/noAccount')
        }
      }
    },
    loadData() {
      this.roles = this.$store.state.roles
      this.removeClerkRole = this.$store.state.removeClerkRole
      this.verifyRole()
      if (this.hasRole('clerk')) {
        this.loadClerkInfo()
      }
      if (this.hasRole('kf')) {
        this.loadKfInfo()
      }
      if (this.hasRole('leader')) {
        this.loadLeaderInfo()
      }
    },
    loadClerkInfo() {
      Promise.all([getClerk(), getItemSwitchList(), getClerkSetting()]).then((results) => {

        const data1 = results[0].data
        const data2 = results[1].data
        const data3 = results[2].data
        if (data1.code != 0) {
          Dialog.alert({
            title: '加载' + this.$store.state.label.clerkLabel + '信息失败',
            desc: data1.msg
          })
        }
        if (data2.code != 0) {
          Dialog.alert({
            title: '加载服务失败',
            message: data2.msg
          })
        }
        if (data3.code != 0) {
          Dialog.alert({
            title: '加载店铺设置失败',
            message: data3.msg
          })
        }

        this.clerk = data1.clerk
        this.clerkJoinCategoryApply = data1.clerkJoinCategoryApply
        this.clerkIsAutoOnline = this.clerk.isAutoOnline
        this.specifySwitch = data2.fixedList
        this.randomSwitch = data2.randomList
        this.dispatchOrderPermission = data1.dispatchOrderPermission || []
        this.itemSwitchList = data2.itemSwitchList
        // data2.itemSwitchList.forEach((item) => {
        //     if (item.type == 1) {
        //         this.specifySwitch.push(item)
        //     } else if (item.type == 2) {
        //         this.randomSwitch.push(item)
        //     }
        // })
        this.clerkItemSwitchIds = data2.clerkItemSwitchIds
        this.allowRandomOrderSwitch = data3.setting.allowRandomOrderSwitch
      }).catch((e) => {
        Dialog.alert({
          title: '加载数据失败',
          message: JSON.stringify(e)
        })
      })
    },
    loadKfInfo() {
      getKf().then(res => {
        const data = res.data;
        if (data.code != 0) {
          Dialog.alert({
            title: '加载客服信息失败',
            desc: data.msg
          })
        }
        this.kf = data.kf
      })
    },
    loadLeaderInfo() {
      getLeader().then(res => {
        const data = res.data;
        if (data.code !== 0) {
          Dialog.alert({
            title: '加载组长信息失败',
            desc: data.msg
          })
        }
        this.leader = data.leader
      })
    },
    updateClerkIsAutoOnline() {
      updateClerkAutoOnlineStatus(this.clerkIsAutoOnline).then(res => {
        const data = res.data;
        if (data.code == 0) {
          Toast("修改成功")
        } else {
          this.clerkIsAutoOnline = false
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          })
        }
      })
    },
    updateStatus(status, role) {
      let updateAutoOnline = false;
      switch (role) {
        case 'clerk':
          this.updateClerkStatusLoading = true
          if (this.$hasFeature('auto_online')) {
            updateAutoOnline = true;
          }
          updateClerkStatus(status, updateAutoOnline).then(res => {
            this.updateClerkStatusLoading = false
            const data = res.data;
            if (data.code == 0) {
              Toast('修改状态成功')
              this.loadClerkInfo()
            } else {
              // this.loadData()
              Dialog.alert({
                title: '修改状态失败',
                message: data.msg
              })
            }
            // this.loadData()
          });
          break;
        case 'kf':
          this.updateKfStatusLoading = true;
          updateKfStatus(status).then(res => {
            this.updateKfStatusLoading = false
            const data = res.data;
            if (data.code == 0) {
              this.kf.status = status
              Toast('修改状态成功')
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改状态失败',
                message: data.msg
              })
            }
          });
          break;
        case 'leader':
          this.updateLeaderStatusLoading = true;
          updateLeaderStatus(status).then(res => {
            this.updateLeaderStatusLoading = false
            const data = res.data;
            if (data.code == 0) {
              this.leader.status = status
              Toast('修改状态成功')
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改状态失败',
                message: data.msg
              })
            }
          });
          break;
      }

    },
    updateRecommendOn(recommendOn) {
      this.updateClerkRecommendOnLoading = true
      updateRecommendOn(recommendOn).then(res => {
        this.updateClerkRecommendOnLoading = false
        const data = res.data;
        if (data.code == 0) {
          Toast('修改成功')
          this.loadData()
        } else {
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          }).then(() => {
            // this.loadData()
          })
        }
      })
    },
    updateRandomOrderSwitch(randomOrderSwitch) {
      updateRandomOrderSwitch(randomOrderSwitch).then(res => {
        const data = res.data;
        if (data.code == 0) {
          Toast('修改成功')
          this.loadData()
        } else {
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          }).then(() => {
            // this.loadData()
          })
        }
      })
    },
    updateItemSwitch(switchId) {
      let switchIds = [].concat(this.clerkItemSwitchIds)
      if (switchIds.indexOf(switchId) != -1) {
        switchIds.splice(switchIds.indexOf(switchId), 1)
      } else {
        switchIds.push(switchId)
      }

      Toast.loading({
        mask: true,
        message: '请稍候'
      })
      updateItemSwitch(
          JSON.stringify(switchIds),
          switchId
      ).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.clerkItemSwitchIds = switchIds
          Toast('修改成功')
        } else {
          // this.loadData()
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          })
        }
      })
    },
    updateClerkRegion(){
      axios.get("/ws/location/v1/ip?key=U4XBZ-63RC7-TIJX5-PPTYI-GBV35-23FQF").then((res) => {
        const status = res.status
        if (status === 200) {
          // 返回的数据
          const data = res.data
          if (data.status == 0) {
            const result = data.result
            // 获取到省、市
            const {province, city} = result.ad_info
            const provinceMap = areas[86]
            for (const key in provinceMap) {
              const provinceName = provinceMap[key]
              if (province && province.includes(provinceName)) {
                // 包含省份
                for(const cityKey in areas[key]) {
                  const cityName = areas[key][cityKey]
                  if (city && city.includes(cityName)) {
                    let regionNames = [provinceName, cityName]
                    let regionCodes = [key, cityKey]
                    // 更新到后端
                    updateRegion(
                        JSON.stringify(regionNames),
                        JSON.stringify(regionCodes)
                    ).then(res => {
                      setRegionTime(new Date().getTime())
                    })
                    return;
                  }
                }
              }
            }
          }
        }
      }).catch((error) => {
      })
    }
  },
  // activated() {
  //   this.loadData()
  // },

  mounted() {
    this.loadData()
  },
  created() {
    const regionTime = getRegionTime()
    // 直接获取缓存的定时标识 有标识就判断一下时间有没有超过2小时 超过了就再定位一次
    if (regionTime) {
      const diffTime = moment().diff(moment(regionTime,'x'), 'seconds')
      if (diffTime >= 2*60*60) {
        // 超过2小时更新一次
        this.updateClerkRegion()
      }
    } else {
      // 没有获取到缓存的定时标识就直接定位一次
      this.updateClerkRegion()
    }
  }
}
</script>

<style lang="less" scoped>

.container{
  background: #F5F6F7;
  padding: 0 15px;

  .Clerk{

    .header{
      display: flex;
      padding: 37px 17px;

      .avatarUrl{
        width: 55px;
        height: 55px;
        border-radius: 222px;
        margin-right: 11px;
      }

      .right{
        padding: 5px 0;
        flex: 1;
        display: flex;
        flex-flow: column;
        justify-content: space-between;

        .line{
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #333;

          .name{
            font-weight: bold;
            font-size: 16px;
          }

          .toInfo{
            display: flex;
            align-items: center;
            font-size: 14px;

            .arrow{
              width: 7px; height: 13px; margin-left: 3px
            }
          }
        }
      }
    }

    .module1 {
      background: #fff;
      border-radius: 11px;
      padding: 13px 0 8px;
      margin-bottom: 20px;

      /deep/.van-switch{
        border: 1px solid rgba(0,0,0,.05);

        .van-switch__node{
          box-shadow: 0 2px 2px 0 rgba(0,0,0,.3);
        }
      }

      .title {
        color: #333;
        font-size: 16px;
        font-weight: bold;
        padding: 0 17px;
        margin-bottom: 19px;
      }

      .switch{
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 15px;

        .switchItem{
          display: flex;
          align-items: center;
          margin-bottom: 15px;
        }
      }

      .skillSwitch{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        color: #333;
        padding: 10px 17px;

        .arrow{
          width: 7px;
          height: 13px;
        }
      }
    }

    .module2{
      background: #fff;
      border-radius: 11px;
      padding: 13px 0 0;

      .title{
        color: #333;
        font-size: 16px;
        font-weight: bold;
        padding: 0 17px;
        margin-bottom: 19px;
      }

      .rowBox{
        display: flex;
        flex-wrap: wrap;

        .Item{
          width: 25%;
          font-size: 12px;
          color:#666666;
          display: flex;
          flex-flow: column;
          align-items: center;
          margin-bottom: 27px;

          .icon{
            width: 28px;
            height: 28px;
            margin-bottom: 8px;
          }
        }
      }
    }
  }
}

.van-cell-group{
  background: none;
}

.grid {
  .item {
    display: block;
    padding: 20px 0;
    text-align: center;
    background: #FFFFFF;

    &:active {
      background: #e5e5e5;
    }

    .icon {

    }

    .text {
      color: #333;
      font-size: 14px;
      margin-top: 6px;
    }
  }
}

.clerk-status {
  position: absolute;
  right: 0;
  bottom: -5px;
  display: flex;
  align-items: center;
}

.item-switch {
  padding: 15px 0;

  .switch-wrap {
    text-align: center;
  }

  .item-name {
    font-size: 10px;
  }
}

.specifyTitle,
.randomTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;

  .down {
    width: 25px;
    transition-duration: 500ms;
  }
}


.specifyFold,
.randomFold {
  overflow: hidden;
  transition-duration: 300ms;
  flex-wrap: wrap;
  overflow-y: auto;
  padding-top: 8px;

  &::-webkit-scrollbar {
    width: 0 !important
  }

  .switchItem {
    width: 25%;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
    font-size: 10px;

    .item-name {
      margin-top: 3px;
    }
  }
}
.switch-title{
  background: #FFFFFF;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title{
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }
  .title-right{
    display: flex;
    align-items: center;
    span{
      font-size: 10px;
      color: #B3B3B3;
      font-weight: 500;
    }
    img{
      width: 22px;
      height: 22px;
      display: block;
    }
  }
}
.switch-body{
  background: #FAFAFA;
  padding: 20px 20px 5px 20px;
  width: calc(100% - 20px * 2);
  .title{
    font-size: 12px;
    color: #666666;
    font-weight: 500;
    margin-bottom: 15px;
  }
  .switch-box{
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .switch{
      width: 33.33%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .switch-name{
        color: #666666;
        font-size: 12px;
        font-weight: 500;
        margin-left: 6px;
        flex: 1;
      }
    }
  }
}
</style>
